import { render, staticRenderFns } from "./demandDetail.vue?vue&type=template&id=65e61ea3&scoped=true"
import script from "./demandDetail.vue?vue&type=script&lang=js"
export * from "./demandDetail.vue?vue&type=script&lang=js"
import style0 from "./demandDetail.vue?vue&type=style&index=0&id=65e61ea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e61ea3",
  null
  
)

export default component.exports